// Completely disable video pausing in slider
document.addEventListener("DOMContentLoaded", () => {
  const origAddEventListener = window.EventTarget.prototype.addEventListener;

  window.EventTarget.prototype.addEventListener = function (
    type,
    listener,
    options
  ) {
    if (
      type === "play" &&
      this.tagName === "VIDEO" &&
      this.closest("[data-slide]")
    ) {
      return; // Block play event listeners on videos in slides
    }
    origAddEventListener.call(this, type, listener, options);
  };
});

// Upsell flickity Slider
let flkty;

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".product-list-upsell-slider");
  if (!slider) return;

  flkty = new Flickity(slider, {
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    cellAlign: "left",
    cellSelector: "quick-add-product",
  });

  document
    .querySelector(".flickity-prev")
    ?.addEventListener("click", () => flkty.previous());
  document
    .querySelector(".flickity-next")
    ?.addEventListener("click", () => flkty.next());
});

document.querySelectorAll(".hide_upsell-product").forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    const quickAdd = this.closest("quick-add-product");
    const upsellBlock = this.closest(".cart-block-upsell");
    if (!quickAdd || !flkty || !upsellBlock) return;

    flkty.remove(quickAdd);

    if (flkty.cells.length === 0) {
      upsellBlock.style.display = "none";
    }

    flkty.resize();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var readMore = document.getElementById("read-more");
  var readLess = document.getElementById("read-less");
  var truncated = document.getElementById("truncated-description");
  var full = document.getElementById("full-description");

  if (readMore && readLess && truncated && full) {
    readMore.addEventListener("click", function () {
      truncated.style.display = "none";
      full.style.display = "block";
    });

    readLess.addEventListener("click", function () {
      full.style.display = "none";
      truncated.style.display = "block";
    });
  }
});

document.querySelectorAll(".tab-link").forEach(function (tab) {
  tab.addEventListener("click", function () {
    var selectedTab = this.getAttribute("data-tab");
    var extraBlocks = document.querySelectorAll(
      ".product__block.tab-content-0"
    );

    extraBlocks.forEach(function (block) {
      block.style.display = selectedTab === "0" ? "block" : "none";
    });
  });
});

// Product page image zoom feature

// const zoomContainers = document.querySelectorAll('product-images .product__slides .product__slide .image-wrapper');

// if(zoomContainers){
//    zoomContainers.forEach((container) => {
//     const img = container.querySelector('img');

//     container.addEventListener('mousemove', (e) => {
//       container.style.cursor = "crosshair";
//       const rect = container.getBoundingClientRect();
//       const x = e.clientX - rect.left;
//       const y = e.clientY - rect.top;

//       img.style.transformOrigin = `${x}px ${y}px`;
//       img.style.transform = 'scale(2)';
//     });

//     container.addEventListener('mouseleave', () => {
//       container.style.cursor = "default";
//       img.style.transform = 'scale(1)';
//     });
//   });
// }

(function () {
  // Select all elements with the 'data-header-expanded' attribute
  const headerElements = document.querySelectorAll("[data-header-expanded]");
  const mainHeader = document.querySelector("header");

  // Function to update the attribute based on scroll position
  function updateHeaderExpanded() {
    const isAtTop = window.scrollY === 0;

    headerElements.forEach((headerElement) => {
      if (isAtTop) {
        headerElement.setAttribute("data-header-expanded", "true");
      } else {
        headerElement.setAttribute("data-header-expanded", "false");
      }
    });
  }
  //Check for Homepage
  const isHP = () => {
    const currentURL = window.location.origin + window.location.pathname;
    const baseURL = window.location.origin + "/";

    console.log(currentURL, baseURL);
    return currentURL === baseURL;
  };

  if (isHP()) {
    //Applies styles only when on HP
    mainHeader.classList.add("animate-header");
    // Add event listener to update on scroll
    window.addEventListener("scroll", updateHeaderExpanded);

    // Initial check in case the page is not loaded at the top
    updateHeaderExpanded();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sliderow__title").forEach(function (title) {
    title.addEventListener("click", function () {
      const wrapper = this.closest(".sliderow-wrap");
      if (wrapper) {
        wrapper.classList.toggle("open");
      }
    });
  });
});




// OPEN drawer
document
  .querySelectorAll(".product-popup-drawer .radio__legend__link")
  .forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      event.stopPropagation();

      const wrapper = trigger.closest(".product-popup-drawer");
      const popupDrawer = wrapper.querySelector(
        ".product-popup-drawer__content"
      );

      // Close all other drawers first
      document
        .querySelectorAll(".product-popup-drawer__content.open")
        .forEach(function (openDrawer) {
          if (openDrawer !== popupDrawer) {
            openDrawer.classList.remove("open");
            openDrawer.classList.add("closing");
            setTimeout(function () {
              openDrawer.classList.remove("closing");
            }, 800);
          }
        });

      popupDrawer.classList.remove("closing");
      popupDrawer.classList.add("open");
      document.body.classList.add("popup-drawer-open");
      document.documentElement.setAttribute("data-scroll-locked", "true");
    });
  });

// CLOSE drawer via close button
document
  .querySelectorAll(".product-popup-drawer__content .product-modal__close")
  .forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.stopPropagation();

      const popupDrawer = button.closest(".product-popup-drawer__content");
      popupDrawer.classList.remove("open");
      popupDrawer.classList.add("closing");

      setTimeout(function () {
        popupDrawer.classList.remove("closing");
      }, 800);

      document.body.classList.remove("popup-drawer-open");
      document.documentElement.removeAttribute("data-scroll-locked");
    });
  });

// CLOSE drawer by clicking outside
document.body.addEventListener("click", function (event) {
  const openDrawer = document.querySelector(
    ".product-popup-drawer__content.open"
  );

  if (
    openDrawer &&
    !event.target.closest(".product-popup-drawer__content") &&
    !event.target.closest(".radio__legend__link")
  ) {
    openDrawer.classList.remove("open");
    openDrawer.classList.add("closing");

    setTimeout(function () {
      openDrawer.classList.remove("closing");
    }, 800);

    document.body.classList.remove("popup-drawer-open");
    document.documentElement.removeAttribute("data-scroll-locked");
  }
});







// Use event delegation to handle dynamic buttons too
document.body.addEventListener("click", function (event) {
  const btn = event.target.closest(".request-price-btn");
  if (!btn) return;

  event.stopPropagation();

  const popupDrawer = document.querySelector(".product-request-price-drawer");
  if (!popupDrawer) return;

  // Set product title into hidden input in the form
  const productTitle = btn.getAttribute("data-product-title");
  const hiddenFieldTitle = popupDrawer.querySelector("#request-product-title-field");

  if (hiddenFieldTitle) {
    hiddenFieldTitle.value = productTitle || "";
  }

  // Close other drawers
  document.querySelectorAll(".product-request-price-drawer.open").forEach(function (openDrawer) {
    if (openDrawer !== popupDrawer) {
      openDrawer.classList.remove("open");
      openDrawer.classList.add("closing");
      setTimeout(function () {
        openDrawer.classList.remove("closing");
      }, 800);
    }
  });

  // Open current drawer
  popupDrawer.classList.remove("closing");
  popupDrawer.classList.add("open");
  document.body.classList.add("popup-drawer-open");
  document.documentElement.setAttribute("data-scroll-locked", "true");
});


// CLOSE via close button
document.querySelectorAll(".product-request-price-drawer .product-modal__close").forEach(function (btn) {
  btn.addEventListener("click", function (event) {
    event.stopPropagation();

    const popupDrawer = btn.closest(".product-request-price-drawer");
    popupDrawer.classList.remove("open");
    popupDrawer.classList.add("closing");

    setTimeout(function () {
      popupDrawer.classList.remove("closing");
    }, 800);

    document.body.classList.remove("popup-drawer-open");
    document.documentElement.removeAttribute("data-scroll-locked");
  });
});

// CLOSE by clicking outside the drawer on body
document.body.addEventListener("click", function (event) {
  const openDrawer = document.querySelector(".product-request-price-drawer.open");

  if (
    openDrawer &&
    !event.target.closest(".product-request-price-drawer") &&
    !event.target.closest(".request-price-btn")
  ) {
    openDrawer.classList.remove("open");
    openDrawer.classList.add("closing");

    setTimeout(function () {
      openDrawer.classList.remove("closing");
    }, 800);

    document.body.classList.remove("popup-drawer-open");
    document.documentElement.removeAttribute("data-scroll-locked");
  }
});

// CLOSE when clicking on .drawer__underlay
document.querySelectorAll(".product-request-price-drawer .drawer__underlay").forEach(function (underlay) {
  underlay.addEventListener("click", function (event) {
    const openDrawer = document.querySelector(".product-request-price-drawer.open");

    if (openDrawer) {
      openDrawer.classList.remove("open");
      openDrawer.classList.add("closing");

      setTimeout(function () {
        openDrawer.classList.remove("closing");
      }, 800);

      document.body.classList.remove("popup-drawer-open");
      document.documentElement.removeAttribute("data-scroll-locked");
    }
  });
});

// SHOPIFY FORMS 

// Use event delegation to handle dynamic buttons too
document.body.addEventListener("click", function (event) {
  const btn = event.target.closest(".request-price-btn");
  if (!btn) return;

  event.stopPropagation();

  const popupDrawer = document.querySelector(".product-request-price-drawer");
  if (!popupDrawer) return;

  // Set product title into hidden input in the form
  const productTitle = btn.getAttribute("data-product-title");
  const hiddenFieldTitle = popupDrawer.querySelector("#custom-product");

  if (hiddenFieldTitle) {
    hiddenFieldTitle.value = productTitle || "";
  }
});  

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("inquiry_submit").addEventListener("click", function () {
    const email = document.getElementById("custom-email").value;
    const product = document.getElementById("custom-product").value;

    const appEmbed = document.querySelector("#app-embed");

    if (appEmbed && appEmbed.shadowRoot) {
      const emailInput = appEmbed.shadowRoot.querySelector('input[id="email"]');
      const productInput = appEmbed.shadowRoot.querySelector('input[id="custom\\#requested_product"]');
      const submitBtn = appEmbed.shadowRoot.querySelector('button[type="submit"]');

      if (emailInput && productInput && submitBtn) {
        // Inject values
        emailInput.value = email;
        productInput.value = product;

        // Trigger input events (for React-style bindings)
        emailInput.dispatchEvent(new Event("input", { bubbles: true }));
        productInput.dispatchEvent(new Event("input", { bubbles: true }));

        // Submit the form
        submitBtn.click();
        console.log("✅ Form submitted via inquiry_submit button.");
      } else {
        console.warn("❌ Fields or button not found in shadow DOM.");
      }
    } else {
      console.warn("❌ Shadow root not accessible.");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const submitBtn = document.getElementById("inquiry_submit");
  const emailInput = document.getElementById("custom-email");
  const consentCheckbox = document.getElementById("request_consent");
  const formContainer = document.querySelector(".custom-requested-form");
  const messageContainer = document.querySelector(".custom-request-form-message");

  const emailError = emailInput.nextElementSibling;
  const consentError = consentCheckbox.closest("label").querySelector(".error");

  submitBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    const consentChecked = consentCheckbox.checked;
    let valid = true;

    // Reset previous errors
    emailError.style.display = "none";
    consentError.style.display = "none";

    // Validate email
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!email || !emailValid) {
      emailError.style.display = "block";
      valid = false;
    }

    // Validate checkbox
    if (!consentChecked) {
      consentError.style.display = "block";
      valid = false;
    }

    if (!valid) return;

    // Add loading animation
    submitBtn.classList.add("btn-loading");

    // Simulate delay
    setTimeout(() => {
      submitBtn.classList.remove("btn-loading");
      formContainer.style.display = "none";
      messageContainer.style.display = "block";
    }, 2000);
  });
});



